import React from 'react';
import { Button, Header, Icon, Popup, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import CoursesTable from './CoursesTable';
import ExamDetails from './ExamDetails';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CoursesList extends React.Component {
    constructor(props) {
        super(props);
        let storedActiveIndex = 0;

        if (localStorage.getItem('activeIndex')) {
            storedActiveIndex = parseInt(localStorage.getItem('activeIndex'), 10);
        }


        this.state = {
            data: [],
            currentAcademicYear: '',

            loading: true,

            activeIndex: storedActiveIndex,
            academicYear: ''
        };

        this.getCourses = this.getCourses.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.showExamDetails = this.showExamDetails.bind(this);
    }

    componentDidMount() {
        window.localStorage.removeItem('id');
        window.localStorage.removeItem('name');

        axios.get('/academic-years/current')
            .then(res => {
                localStorage.setItem('currentAcademicYear', res.data.id);
                this.setState({ currentAcademicYear: res.data.id, academicYear: res.data.id });
                if (parseInt(localStorage.getItem('academicYear'), 10)) {
                    this.getCourses(parseInt(localStorage.getItem('academicYear'), 10));
                } else {
                    this.getCourses(res.data.id);
                }
            })
            .catch(err => {
                console.log('Failed to fetch current academic year');
            });
    }


    getCourses(academicYearId) {
        this.setState({ loading: true });
        let academicYear = {};
        academicYear = { ...academicYear, academicYearId };
        localStorage.setItem('academicYear', academicYearId);
        axios.get('course/filter-implementations/', { params: academicYear })
            .then(res => {
                const dataa = res.data;
                this.setState({ data: dataa, loading: false });
            })
            .catch(err => {
                if (err.message === 'Network Error') {
                    this.getCourses();
                } else {
                    this.setState({
                        error: true,
                        loading: false
                    });
                    console.log('Failed to fetch courses');
                }
            });
    }


    getFilterData(courseImplementationName, courseCode) {
        let academicYearId = localStorage.getItem('academicYear') ?
            parseInt(localStorage.getItem('academicYear'), 10)
            : parseInt(localStorage.getItem('currentAcademicYear'), 10);

        let docFilter = {};
        docFilter = { ...docFilter, academicYearId };
        if (courseImplementationName) docFilter = { ...docFilter, courseImplementationName };
        if (courseCode) docFilter = { ...docFilter, courseCode };

        if (this.state.showFilterMode) {
            if (courseImplementationName || courseCode) {
                this.setState({ showFiltersOnButton: true, showFilterMode: false });
            } else {
                toast('Morate unijeti po čemu želite filtrirati podatke!');
            }
        }
        axios.get('course/filter-implementations/', { params: docFilter })
            .then(res => {
                const filterData = res.data;
                this.setState({ filterData });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }


    showExamDetails(mode = true) {
        this.setState({ examDetails: mode });
    }

    render() {
        return (
            <div>

                {this.state.examDetails ?
                    <ExamDetails showExamDetails={this.showExamDetails} />

                    :
                    <div>
                        <Header as="h1">  Kreiranje i prikaz ispita po predmetima</Header>
                        <Segment.Group raised >
                            <Segment clearing>
                                <Header as="h3">
                                  Spisak predmeta
                                </Header>
                            </Segment>

                            <Segment>
                                <CoursesTable
                                    getCoursesByAcademicYear={this.getCourses}
                                    data={this.state.data}
                                    showExamDetails={this.showExamDetails}
                                    currentAcademicYear={this.state.currentAcademicYear}
                                    loader={this.state.loading}
                                />
                            </Segment>
                            <ToastContainer hideProgressBar pauseOnFocusLoss={false} />
                        </Segment.Group>
                    </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/CoursesList.js